/* UMM registered mark: keep "Elevated Bathing Rituals(R)" on one line everywhere (Oct 2026). */
(function () {
  if (window.__ummTM) return; window.__ummTM = true;
  var RE = /(Elevated)[ \t\r\n]+(Bathing)[ \t\r\n]+(Rituals?)[ \t\r\n]*(®?)/gi;
  var NB = ' ';
  var SKIP = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, INPUT: 1, NOSCRIPT: 1, CODE: 1, PRE: 1 };
  var touched = [];
  function fix(root) {
    if (!root) return;
    if (root.nodeType === 3) root = root.parentNode;
    if (!root || root.nodeType !== 1) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var p = n.parentNode;
        if (!p || SKIP[p.nodeName] || p.isContentEditable) return NodeFilter.FILTER_REJECT;
        RE.lastIndex = 0;
        return RE.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
    var list = [], n;
    while ((n = w.nextNode())) list.push(n);
    list.forEach(function (t) {
      var v = t.nodeValue.replace(RE, function (m, a, b, c, r) { return a + NB + b + NB + c + r; });
      if (v !== t.nodeValue) t.nodeValue = v;
      touched.push(t.parentNode);
    });
  }
  /* A short line too narrow for the whole name scales itself down instead of overflowing. */
  function fit() {
    var seen = [];
    touched.forEach(function (el) {
      var box = el;
      while (box && box !== document.body && getComputedStyle(box).display === 'inline') box = box.parentElement;
      if (!box || seen.indexOf(box) !== -1) return;
      seen.push(box);
      if (!box.clientWidth || box.scrollWidth <= box.clientWidth + 1) return;
      var cs = getComputedStyle(box);
      if (/auto|scroll/.test(cs.overflowX) || box.textContent.length > 120) return;
      var fs = parseFloat(cs.fontSize), min = fs * 0.55, guard = 0;
      while (box.scrollWidth > box.clientWidth + 1 && fs > min && guard++ < 40) {
        fs -= 1; box.style.fontSize = fs + 'px';
      }
    });
    touched = [];
  }
  function run() { fix(document.body); fit(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  var pending = [], queued = false;
  new MutationObserver(function (ms) {
    ms.forEach(function (m) { if (m.addedNodes) m.addedNodes.forEach(function (n) { pending.push(n); }); });
    if (queued) return; queued = true;
    requestAnimationFrame(function () {
      queued = false;
      var batch = pending; pending = [];
      batch.forEach(function (n) { if (n && n.isConnected) fix(n); });
      fit();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
  var rt;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(function () {
      document.querySelectorAll('[style*="font-size"]').forEach(function (e) {
        if (/Elevated Bathing/i.test(e.textContent)) { e.style.fontSize = ''; touched.push(e); }
      });
      fit();
    }, 200);
  });
})();
